<script lang="ts" setup>
import { useDeviceType } from 'theme/composables/useDeviceType';

const { isDesktop } = useDeviceType();
</script>

<template>
  <div :class="$style.container">
    <h2 :class="$style.title">主な取り組み</h2>
    <ul>
      <li :class="$style.action">
        <h3 :class="$style.action__title">定期的な研修の実施</h3>
        <ul>
          <li :class="$style.action__listitem">
            コンプライアンス研修、金融商品研修など
          </li>
        </ul>
      </li>
      <li :class="$style.action">
        <h3 :class="$style.action__title">資格取得</h3>
        <ul>
          <li :class="$style.action__listitem">
            公的保険アドバイザー、FP1級、FP2級、AFP又はCFPの資格取得
          </li>
        </ul>
      </li>
      <li :class="$style.action">
        <h3 :class="$style.action__title">
          保険募集及び金融サービス仲介状況のモニタリング
        </h3>
        <ul>
          <li :class="$style.action__listitem">
            保険募集の場合 :
            ユーザーの皆さまそれぞれの状況や意向を適切に把握できているか当社独自帳票を通じて確認
          </li>
          <li :class="$style.action__listitem">
            金融サービス仲介業の場合 :
            必要な説明がなされているか録画を通じて確認
          </li>
        </ul>
      </li>
      <li :class="$style.action">
        <h3 :class="$style.action__title">推奨方針・推奨商品の見直し</h3>
        <ul>
          <li :class="$style.action__listitem">
            ユーザーの皆さまのニーズと最新の保険商品その他オンライン募集の適切性等を考慮して、推奨方針・推奨商品を定期的に見直す
          </li>
          <li :class="$style.action__listitem">変額保険の取扱いを不可とする</li>
        </ul>
      </li>
      <li :class="$style.action">
        <h3 :class="$style.action__title">
          金融商品の募集・勧誘における説明態勢の充実
        </h3>
        <ul>
          <li :class="$style.action__listitem">
            運用型生命保険と債券、投資信託との比較説明の実施
          </li>
          <li :class="$style.action__listitem">
            ライフプランニングの作成及び保険の販売において公的保険制度の説明の必須化
          </li>
          <li :class="$style.action__listitem">
            ユーザーの皆さまの状況をヒアリングし、公的保険制度を説明しているか当社独自帳票を通じて確認
          </li>
        </ul>
      </li>
      <li :class="$style.action">
        <h3 :class="$style.action__title">
          成約後のユーザーの皆さまへ金融セミナー実施
        </h3>
      </li>
      <li :class="$style.action">
        <h3 :class="$style.action__title">
          今後の家計等に関するアフターフォロー面談実施
        </h3>
      </li>
      <li :class="$style.action">
        <h3 :class="$style.action__title">
          金融商品の販売実績と報酬との関係遮断
        </h3>
        <ul>
          <li :class="$style.action__listitem">
            アドバイザーの金融商品販売実績と報酬は連動しない報酬体系の採用
          </li>
        </ul>
      </li>
      <li :class="$style.action">
        <h3 :class="$style.action__title">
          情報セキュリティ・個人情報の高度な管理体制の構築
        </h3>
        <ul>
          <li :class="$style.action__listitem">ISMS及びPマーク取得</li>
        </ul>
      </li>
      <li :class="$style.action">
        <h3 :class="$style.action__title">
          書類記入の負担低減、手続き完了までの迅速化
        </h3>
        <ul>
          <li :class="$style.action__listitem">
            ペーパーレスでの契約手続きを行うことで、書類記入や書類不備等でお客様の負担をおかけせず迅速に保険契約を成立させる
          </li>
        </ul>
      </li>
    </ul>
    <a
      :class="$style.link"
      href="https://okane-kenko.jp/policies/fiduciaryduty"
    >
      <img
        v-if="isDesktop"
        :class="$style.link__image"
        src="./banner_pc.svg"
        alt="詳細はこちら"
      />
      <img
        v-else
        :class="$style.link__image"
        src="./banner_sp.svg"
        alt="詳細はこちら"
      />
    </a>
  </div>
</template>

<style lang="scss" module>
.container {
  width: 100%;
  background-color: $color-gray-100;
  padding: 56px 16px 64px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @include desktop-only {
    padding: 72px 16px 88px 16px;
  }
}

.title {
  color: 030e1a;
  font-size: 22px;
  font-weight: 900px;
  letter-spacing: 8px;
}

.action {
  margin-top: 38px;
  padding: 16px 16px 18px 16px;
  background-color: $color-white-1000;
  border-radius: 8px;

  @include desktop-only {
    width: 688px;
  }

  &:nth-child(n + 2) {
    margin-top: 6px;
  }

  &__title {
    font-size: 15px;
    font-style: normal;
    font-weight: bold;
    line-height: 165%;
  }

  &__listitem {
    margin-top: 6px;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 165%;
  }
}

.link {
  margin-top: 64px;

  @include desktop-only {
    margin-top: 88px;
  }

  &__image {
    vertical-align: top;
  }
}
</style>
